import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

/**
 * Create or update final list item
 * @param {number} studentId - student ID
 * @param {Object} payload - request data
 * @param {number} payload.school - college ID
 * @param {number} payload.designationName - classification (reach|likely|target)
 * @param {string} version
 */
export const createOrUpdateItem = ({
  studentId,
  payload,
  version = 'v1',
} = {}) => {
  let url = `${version}/final-list/items/`;

  if (studentId) {
    url += `${studentId}/`;
  }

  return client
    .request({
      url,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);
};

/**
 * Retrieve a list of colleges in the final list for the given student
 * @param {number} studentId
 * @param {string} version
 */
export const getItemList = ({ params, studentId, version = 'v1' } = {}) => {
  let url = `${version}/final-list/items/`;

  if (studentId) {
    if (studentId === 'me') {
      url += '/';
    } else {
      url += `${studentId}/`;
    }
  }
  return client
    .request({
      url,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
};

/**
 * Delete a college from the final list
 * @param {string} itemId - uuid of the final list item
 * @param {number} studentId
 * @param {string} version
 */
export const deleteItem = ({ itemId, studentId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/final-list/item/${itemId}/${studentId}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Retrieve a list of colleges that student favorited or added to school lists
 * @param {string} version
 */
export const getSchoolAndFavoriteList = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/final-list/school-list-favorites/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Retrieve final list config
 * @param {string} version
 */
export const getConfiguration = ({ version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/final-list/configuration/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Verify student's final list
 * @param {number} studentId
 * @param {string} version
 */
export const verifyList = ({ studentId, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/final-list/items/${studentId}/verify/`,
      method: RequestMethod.POST,
    })
    .then(handleJSONResponse)
    .catch(handleError);

/**
 * Get a classification for a given college and student
 * @param {number} studentId
 * @param {number} schoolId
 * @param {string }version
 */
export const getClassification = ({
  studentId,
  schoolId,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/final-list/school/${schoolId}/student/${studentId}/classify/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFinalList = ({ version = 'v1', payload = {}, params } = {}) =>
  client
    .request({
      url: `${version}/activity/activity-entities/`,
      method: RequestMethod.POST,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getFinalListSelectivity = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/final-list/selectivity/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
